// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"576":"ce5bf8d6","631":"15491e31","670":"7e7b2267"}[chunkId] + ".chunk.css";
};